export const LEGAL_VERSION = "1.2.0";
export const LEGAL_EFFECTIVE_DATE = "17 August 2026";
export const CONTACT_EMAIL = "contact@jomkonvoi.com";

export const legalDocuments = {
  privacy: {
    slug: "privacy",
    path: "/legal/privacy",
    title: "Privacy Policy",
    summary: "What data we collect, why, and how you control it.",
  },
  terms: {
    slug: "terms",
    path: "/legal/terms",
    title: "Terms of Service",
    summary: "The rules for using JomKonvoi.",
  },
  "data-deletion": {
    slug: "data-deletion",
    path: "/legal/data-deletion",
    title: "Manage & Delete Your Data",
    summary: "See, export, and permanently delete your JomKonvoi data.",
  },
  safety: {
    slug: "safety",
    path: "/legal/safety",
    title: "Safety Guidelines",
    summary: "How to use JomKonvoi without getting anyone hurt.",
  },
};

export const legalList = [
  legalDocuments.privacy,
  legalDocuments.terms,
  legalDocuments["data-deletion"],
  legalDocuments.safety,
];
